module.exports = __webpack_public_path__ + "static/media/ballroom.08d43676.jpg";